import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ReviewerDecision = () => {
    const platformId = localStorage.getItem('platformID');
    const authorId = localStorage.getItem('AuthorID');
    const [submissions, setSubmissions] = useState([]);
    const [selectedSubmissionId, setSelectedSubmissionId] = useState('');
    const [reviews, setReviews] = useState([]);
    const [replies, setReplies] = useState({});
    const API = process.env.REACT_APP_API_BASE_URL;

    // Sujay 3/6/2025: Add the code layout Plugin for the PDF

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            toolbarSlot: (slots) => {
                const { Download, ...rest } = slots;
                return { ...rest };
            },
        },
    });

    useEffect(() => {
        if (authorId && platformId) {
            axios.get(`${API}/api/reviewer-decision/submissions/${authorId}/${platformId}`)
                .then(res => {
                    setSubmissions(res.data)
                    console.log(res.data);
            
                })
                .catch(err => console.error(err));
        }
    }, [authorId, platformId]);

    useEffect(() => {
        if (selectedSubmissionId) {
            // Sujay 3/6/2025: Also get the File to show on the screen
            axios.get(`${API}/api/reviewer-decision/reviews/${authorId}/${selectedSubmissionId}`)
                .then(res => {

                    setReviews(res.data)
                    // console.log(res.data);
                })
                .catch(err => console.error(err));
        }
    }, [selectedSubmissionId]);

    const handleReplyChange = (srid, value) => {
        setReplies(prev => ({ ...prev, [srid]: value }));
    };

    const handleReplySubmit = async (srid, submissionID) => {
        try {
            await axios.put(`${API}/api/reviewer-decision/reply`, {
                Srid: srid,
                AuthorReply: replies[srid],
                submissionID: submissionID
            });
            alert('Reply submitted.');
            // Refresh reviews
            const res = await axios.get(`${API}/api/reviewer-decision/reviews/${authorId}/${selectedSubmissionId}`);
            setReviews(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="container my-4 ml-2 ">
            <h3 className="page-title mb-4">Reviewer Decisions & Comments</h3>

            {/* Submissions Dropdown */}
            <div className="mb-4">
                <label className="form-label fw-bold">Select Submission</label>
                <select
                    className="form-select"
                    value={selectedSubmissionId}
                    onChange={(e) => setSelectedSubmissionId(e.target.value)}
                >
                    <option value="">-- Select Submission --</option>
                    {submissions.map(sub => (
                        <option key={sub.submissionID} value={sub.submissionID}>
                            {sub.SubmissionTitle}
                        </option>
                    ))}
                </select>
            </div>

            <div className="row g-4">
                {/* Sujay 3/6/2025: Adding PDF column */}
                <div className="col-md-6">
                    <div className="card shadow-sm h-100">
                        <div className="card-header bg-info text-white">
                            <strong>Submitted Paper</strong>
                        </div>
                        <div className="card-body" style={{ height: '600px' }}>
                            {/* Getting file name at 0th index */}
                            {reviews?.[0]?.File?.endsWith('.pdf') ? (
                                <Worker workerUrl="/pdf.worker.min.js">
                                    <Viewer
                                        fileUrl={`${API}/uploads/papers/${reviews[0].File}`}
                                        plugins={[defaultLayoutPluginInstance]}
                                    />
                                </Worker>
                            ) : (
                                <div className="alert alert-secondary">File is not a valid PDF or not available</div>
                            )}
                        </div>
                    </div>
                </div>



                {/* Reviews and Replies */}{/* Reviwer Feedback */}
                <div className="col-md-6">

                    <div className="card shadow-sm">
                        <div className="card-header bg-info text-white">
                            <strong>HOST Feedback (Accept Or rejct)</strong>
                        </div>
                        {reviews.length ? <div className="card-body">
                            {
                                (reviews[0].Status === "Pending" && reviews[0].IsReview === "Reviewed") ? "Accept" : reviews[0].Status}
                        </div>
                            : <div className='alert alert-secondary m-2'>No Decision</div>}

                    </div>

                    <div className="card shadow-sm">
                        {/* Accept or reject feedback */}

                        <div className="card shadow-sm">
                            <div className="card-header bg-info text-white">
                                <strong>Reviewer Feedback (Accept Or rejct)</strong>
                            </div>
                            <div className="card-body">
                                {reviews.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Reviewer</th>
                                                    <th>Decision</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reviews.map(review => (
                                                    // Sujay 2/6/2025: If the reviewer comment is present then only you can reply
                                                    !(review.Comment) && (
                                                        <tr key={review.Srid}>
                                                            <td>
                                                                <b>
                                                                    {review.ReviewerName
                                                                        ? `${review.ReviewerName.charAt(0)}*****${review.ReviewerName.charAt(review.ReviewerName.length - 1)}`
                                                                        : 'Anonymous'}
                                                                </b>
                                                            </td>
                                                            <td>{review.Decision}</td>
                                                        </tr>
                                                    )
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-secondary">Select a submission to view reviews.</div>
                                )}
                            </div>
                        </div>
                        {/* Reviewer feedback */}
                        <div className="card-header bg-info text-white">
                            <strong>Reviewer Feedback</strong>
                        </div>
                        <div className="card-body">
                            {reviews.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Reviewer</th>
                                                <th>Decision</th>
                                                <th>Comment</th>
                                                <th>Author Reply</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reviews.map(review => (
                                                // Sujay 2/6/2025: If the reviewer comment is present then only you can reply
                                                review.Comment && (
                                                    <tr key={review.Srid}>
                                                        <td>
                                                            <b>
                                                                {review.ReviewerName
                                                                    ? `${review.ReviewerName.charAt(0)}*****${review.ReviewerName.charAt(review.ReviewerName.length - 1)}`
                                                                    : 'Anonymous'}
                                                            </b>
                                                        </td>
                                                        <td>{review.Decision}</td>
                                                        <td>{review.Comment}</td>
                                                        <td>
                                                            {review.AuthorReply ? (
                                                                <>
                                                                    <div className="fw-bold">{review.AuthorReply}</div>
                                                                    <div className="text-muted small">
                                                                        {new Date(review.AuthorReplayDate).toLocaleString()}
                                                                    </div>
                                                                </>
                                                            ) : review.Status === 'Accept' ? (
                                                                <span className="text-success">Accepted. Cannot reply.</span>
                                                            ) : (
                                                                <textarea
                                                                    className="form-control"
                                                                    rows="5"
                                                                    style={{ minWidth: '20rem', fontSize: '1rem' }}
                                                                    value={replies[review.Srid] || ''}
                                                                    onChange={(e) => handleReplyChange(review.Srid, e.target.value)}
                                                                />
                                                            )}
                                                        </td>
                                                        <td>
                                                            {review.Status !== 'Accept' && !review.AuthorReply && (
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary mt-1"
                                                                    onClick={() => handleReplySubmit(review.Srid, review.submissionID)}
                                                                >
                                                                    Submit
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="alert alert-secondary">Select a submission to view reviews.</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewerDecision;
